import { post, postAsyncV2 } from "./apiManager";

export const sendOTP = (phoneNumber, onSuccess, onFailed) => {
  postAsyncV2("otp-v2", {
    MobileNumber: phoneNumber,
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data.data, data);
    })
    .catch((error) => {
      onFailed(error);
    });
};

export const sendOtpV2 = async (mobileNumber) => {
  const response = await postAsyncV2("otp-v2", {
    MobileNumber: mobileNumber,
  });
  const data = await response.json();
  return data;
};

export const verifyOTP = (phoneNumber, otpValue, onSuccess, onFailed) => {
  postAsyncV2("/verify-otp-v2", {
    MobileNumber: phoneNumber,
    OTPValue: otpValue,
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data.data, data);
    })
    .catch((error) => {
      onFailed(error);
    });
};

export const verifyOtpV2 = async (mobileNumber, otpValue) => {
  const response = await postAsyncV2("/verify-otp-v2", {
    MobileNumber: mobileNumber,
    OTPValue: otpValue,
  });
  const data = await response.json();
  if (data.message	 === "Success") {
    return true;
  }
  return false;
  //  const data = await response.json();
  //  return data;
};
